import React from 'react';

import PelmeshkaLogo from '../../../assets/images/pelmeshkalogo.png';
import { Box } from '@mui/material';



export default function Logo() {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      height={{ xs: '50vh', sm: '80vh' }}
      pt={{xs: 0, sm: 0}} // 241128 MS - xs was 60, replaced to 0 
    >
      <img src={PelmeshkaLogo} alt="pelmeshka_logo" height="100%" />
    </Box>
  );
}
